module.exports = __webpack_public_path__ + "static/shield-394f4b3b69917a81b70a4a862bf2271b.png";